import { render, staticRenderFns } from "./textItem.vue?vue&type=template&id=40ed2040&scoped=true"
import script from "./textItem.vue?vue&type=script&lang=js"
export * from "./textItem.vue?vue&type=script&lang=js"
import style0 from "./textItem.vue?vue&type=style&index=0&id=40ed2040&prod&lang=css"
import style1 from "./textItem.vue?vue&type=style&index=1&id=40ed2040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed2040",
  null
  
)

export default component.exports